export default __webpack_public_path__ + "static/media/CW.1f44793d.svg";